export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/favicon.9c3a6176.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};